import { useRef } from 'react'
import FileInput from 'components/form/FileInput'
import { useSelector } from 'react-redux'
import { FILE_COUNT_LIMIT } from 'features/image/ImageLibraryModal'
import { func } from 'prop-types'
import { getEventFiles } from '../../utils'

const ImageDropArea = ({ setDragOver, handleFileChange }) => {
  const { images, uploading } = useSelector(state => state.image.imageLibrary)
  const ref = useRef()
  const handleDrop = e => {
    e.preventDefault()
    const files = getEventFiles(e)
    handleFileChange(files)
    setDragOver(false)
  }
  const handleDragLeave = event => {
    event.stopPropagation()
    if (!ref.current.contains(event.target) || ref.current === event.target) {
      setDragOver(false)
    }
  }
  const handleDragEnter = () => {
    setDragOver(true)
  }
  const handleDragOver = event => {
    event.preventDefault()
    setDragOver(true)
  }
  return (
    <div
      ref={ref}
      className="drop_area"
      onDrop={handleDrop}
      onDragEnter={handleDragEnter}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}>
      <div className="reform_item_file">
        <FileInput
          id="fileImg20"
          className="inp_file"
          clearFiles
          multiple
          accept=".png,.jpeg,.jpg"
          onFileChange={handleFileChange}
          disabled={uploading || images.length === FILE_COUNT_LIMIT}
        />
        <label htmlFor="fileImg20" className="file_info">
          <span className="reform_img_file">
            <span className="ico_comm reform_ico_img" />
          </span>
          <span className="reform_txt_file">
            <span className="txt_upload">
              업로드할 이미지를 끌어다 놓으세요.
            </span>
            <span className="txt_byte">JPG, JPEG, PNG</span>
          </span>
        </label>
      </div>
    </div>
  )
}
ImageDropArea.propTypes = {
  setDragOver: func,
  handleFileChange: func,
}
export default ImageDropArea
